import Api from '@/services/Index';
const eslAttendanceReport = async (config) => {
    return Api.get('/esl/reports/attendance', config);
}
const numberOfStudents = async (config) => {
    return Api.get('/esl/reports/number-of-students', config);
}
const conditionalPass = async (config) => {
    return Api.get('/esl/reports/conditional-pass', config);
}
const passFailReport = async (config,year) => {
    return Api.get(`/esl/reports/session/pass-fail-by-year/${year}`, config);
}
const passFailDataBySession = async (config) => {
    return Api.get(`/esl/reports/pass-fail-by-session`, config);
}
const genderReport = async (config,year) => {
    return Api.get(`/esl/reports/gender-distribution-by-year/${year}`, config);
}
const studentTimeOf = async (config) => {
    return Api.get(`/esl/reports/student-time-off`, config);
}
const eslReportsAchievementScale = async (config) => {
    return Api.get(`/esl/reports/achievement-scales`, config);
}
const passFailRateDataByLevel = async (config) => {
    return Api.get(`/esl/reports/pass-fail-rate-by-level`, config);
}
const passFailDataByAssessment = async (config) => {
    return Api.get(`/esl/reports/pass-fail-data-by-assessment`, config);
}
const visaTypeReportForYear = async (config,year) => {
    return Api.get(`/esl/reports/visa-type-report/${year}`, config);
}
const countryReport = async (config) => {
    return Api.get(`/esl/reports/country`, config);
}
const getPassFailDataByAssessmentOptions = async (formData) => {
    return Api.get(`/esl/reports/pass-fail-data-by-assessment/level/options`, formData);
}
const getTransferOut = async (formData) => {
    return Api.get(`/esl/reports/transfer-out-report`, formData);
}
const receivedPaymentsReport = async (config) => {
    return Api.get(`/esl/reports/received-payments`, config);
}

const paymentDetailReport = async (config) => {
    return Api.get(`/esl/reports/payment-details-report`, config);
}

const mentoraSevisRegistrationReport  = async (config) => {
    return Api.get(`/esl/reports/mentora-sevis-registration-report`, config);
}

const rosterReport  = async (config) => {
    return Api.get(`/esl/reports/roster`, config);
}

const previewRosterReport  = async (config) => {
    return Api.get(`/esl/reports/preview-roster`, config);
}

const MediaOptOutReport  = async (config) => {
    return Api.get(`/esl/reports/media-opt-out`, config);
}

const mentoraCurrentStudentsNotRegistretedReport  = async (config) => {
    return Api.get(`/esl/reports/current-students-not-registered`, config);
}
const terminationCompletion  = async (config) => {
    return Api.get(`/esl/reports/termination-completion`, config);
}
const reportsStudentCourseRegistration  = async (config) => {
    return Api.get(`/esl/reports/student-course-registration`, config);
}
const missingEnrollmentAgreementReport  = async (config) => {
    return Api.get(`/esl/reports/missing-enrollment-agreements`, config);
}
const level600ClassAssignment  = async (config) => {
    return Api.get(`/esl/reports/level-600-class-assignment`, config);
}
const level100and500ClassAssignment  = async (config) => {
    return Api.get(`/esl/reports/level-100and500-class-assignment`, config);
}
const collectionReport  = async (config) => {
    return Api.get(`/esl/reports/collection`, config);
}
const bank_reconciliation  = async (config) => {
    return Api.get(`/esl/reports/bank-reconciliation`, config);
}
const AttendanceEntryTracking  = async (config) => {
    return Api.get(`/esl/reports/attendance-entry-tracking`, config);
}
const agencyReport  = async (config) => {
    return Api.get(`/esl/reports/agency`, config);
}
const historyModuleReport  = async (config) => {
    return Api.get(`/esl/reports/history-of-module`, config);
}
const moduleStudentList = async (config) => {
    return Api.get('/esl/reports/module-student-list', config);
}
const moduleEnrollmentComparison = async (config) => {
    return Api.get('/esl/reports/module-enrollment-comparison', config);
}

export default {
    eslAttendanceReport,
    numberOfStudents,
    conditionalPass,
    passFailReport,
    passFailDataBySession,
    genderReport,
    studentTimeOf,
    eslReportsAchievementScale,
    passFailRateDataByLevel,
    passFailDataByAssessment,
    visaTypeReportForYear,
    countryReport,
    getPassFailDataByAssessmentOptions,
    getTransferOut,
    receivedPaymentsReport,
    paymentDetailReport,
    mentoraSevisRegistrationReport,
    rosterReport,
    previewRosterReport,
    MediaOptOutReport,
    mentoraCurrentStudentsNotRegistretedReport,
    terminationCompletion,
    reportsStudentCourseRegistration,
    missingEnrollmentAgreementReport,
    level600ClassAssignment,
    level100and500ClassAssignment,
    collectionReport,
    bank_reconciliation,
    AttendanceEntryTracking,
    agencyReport,
    historyModuleReport,
    moduleStudentList,
    moduleEnrollmentComparison
}

